/**
 * Ory APIs
 *
 * Contact: support@ory.sh
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * VerifiableAddress is an identity\'s verifiable address
 */
export interface VerifiableIdentityAddress { 
    /**
     * When this entry was created
     */
    created_at?: string;
    /**
     * The ID
     */
    id?: string;
    /**
     * VerifiableAddressStatus must not exceed 16 characters as that is the limitation in the SQL Schema
     */
    status: string;
    /**
     * When this entry was last updated
     */
    updated_at?: string;
    /**
     * The address value  example foo@user.com
     */
    value: string;
    /**
     * Indicates if the address has already been verified
     */
    verified: boolean;
    verified_at?: string;
    /**
     * The delivery method
     */
    via: VerifiableIdentityAddress.ViaEnum;
}
export namespace VerifiableIdentityAddress {
    export type ViaEnum = 'email' | 'sms';
    export const ViaEnum = {
        Email: 'email' as ViaEnum,
        Sms: 'sms' as ViaEnum
    };
}


